import React from 'react';
function ChatOutlined() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M4 4h16v12H5.17L4 17.17V4m0-2c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4z" }),
        React.createElement("path", { d: "M6 12h8v2H6v-2zM6 9h12v2H6V9zM6 6h12v2H6V6z" })));
}
export default ChatOutlined;
